/* eslint-disable @typescript-eslint/no-explicit-any */
import { RoleEnum } from '@shared/enum/role.enum';
import { UserStatusEnum } from '@shared/enum/user.enum';
import { IAesEncryptOutput } from '@shared/interface/crypto.interface';
import {
  IBackendDate,
  IRefreshToken,
  IUser,
} from '@shared/interface/model.interface';

export class UserDto implements IUser {
  public id = 0;
  public username?: string = undefined;
  public email?: string = undefined;
  public roles?: RoleEnum[] = [];
  public isActiveLocally?: number = undefined;
  public status?: UserStatusEnum = undefined;
  public refreshToken?: IRefreshToken = undefined;
  public chkRemember?: boolean = undefined;
  public lastConnectionAt?: IBackendDate = undefined;
  public newConnectionAt?: IBackendDate = undefined;
  public uuid?: string = undefined;

  constructor(init?: Partial<any>) {
    (Object as any).assign(this, init);
  }
}
